export const carouselTestimonialComponent = {
  key: 'carouselTestimonialComponent',
  name: 'Carousel Testimonial Component',
  siteIdentifier: 'global',

  testimonialAlt: 'Testimonial',
  testimonialStarsContainerAlt: '{rating} star rating out of 5',
};
